//imports
import {
	AUTH_REFRESH_TOKEN,
	AUTH_REFRESH_TOKEN_RESULT,
	AUTH_CHANGE_PASSWORD_OPEN_MODAL,
	AUTH_CHANGE_PASSWORD_REQUEST,
	AUTH_CHANGE_PASSWORD_RESULT,
	AUTH_GET_PREFERENCES_REQUEST,
	AUTH_GET_PREFERENCES_RESULT,
	AUTH_GET_AUTHENTICATION_DETAILS_REQUEST,
	AUTH_GET_AUTHENTICATION_DETAILS_RESULT,
} from 'Redux/actionTypes';

export const refreshToken = () => ({
	type: AUTH_REFRESH_TOKEN
})

export const refreshTokenResult = (result = true) => ({
	type: AUTH_REFRESH_TOKEN_RESULT,
	payload: result
})

export const changePasswordOpenModal = (open) => ({
	type: AUTH_CHANGE_PASSWORD_OPEN_MODAL,
	payload: open
});

export const changePasswordRequest = (data) => ({
	type: AUTH_CHANGE_PASSWORD_REQUEST,
	payload: data
});

export const changePasswordResult = (result, error) => ({
	type: AUTH_CHANGE_PASSWORD_RESULT,
	payload: { result, error }
});

export const authGetPreferencesRequest = () => ({
	type: AUTH_GET_PREFERENCES_REQUEST,
})

export const authGetPreferencesResult = (result) => ({
	type: AUTH_GET_PREFERENCES_RESULT,
	payload: result
})

export const authGetAuthenticationDetailsRequest = () => ({
	type: AUTH_GET_AUTHENTICATION_DETAILS_REQUEST
})

export const authGetAuthenticationDetailsResult = (result, error = null) => ({
	type: AUTH_GET_AUTHENTICATION_DETAILS_RESULT,
	payload: result,
	error
})